<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="description" slot-scope="description">
          <div>{{description}}</div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-exam-type ref="editExamType" @edited="handleEdited"/> -->
              Edit
            </a>
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <edit-exam-type ref="editExamType" @edited="handleEdited"/>
  </div>
</template>
<script>
import EditExamType from '@/components/bosemexam/types/Forms/Edit/index'

const columns = [
  {
    title: 'Exam Types',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Descriptions',
    dataIndex: 'description',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'ExamTypesTable',
  components: {
    EditExamType,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editExamType.showModal(record.id)
      this.$eventBus.$emit('openExamTypeEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete this exam type!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/examtype/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
